import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _08a40534 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _58eda9cf = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _cb0a2854 = () => interopDefault(import('../pages/main_console.vue' /* webpackChunkName: "pages/main_console" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login/",
    component: _08a40534,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/logout/",
    component: _58eda9cf,
    pathToRegexpOptions: {"strict":true},
    name: "logout"
  }, {
    path: "/main_console/",
    component: _cb0a2854,
    pathToRegexpOptions: {"strict":true},
    name: "main_console"
  }, {
    path: "/",
    redirect: "/main_console/",
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
